import {Component, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {Toast, ToastsManager} from 'ng2-toastr';
import {AppService} from '../../../appService';
import {LocalStorageService, SessionStorageService} from 'ngx-webstorage';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-meeting-with-student-by-head',
  templateUrl: './meeting-with-student-by-head.component.html',
  styleUrls: ['./meeting-with-student-by-head.component.css']
})
export class MeetingWithStudentByHeadComponent implements OnInit {
  reasonForMeetingOrSemesterFilter: any = '';

  teacherId: any = '';
  studentId: any = '';
  selectedSemesterIdToSearchMeeting = '';
  semesterList: any = [];
  meetingList: any = [];


  date = new Date();
  cdnLocMentoring= environment.cdnLocMentoring;
  @ViewChild('fileInput') fileInput;


  constructor(private appService: AppService,
              private localStorage: LocalStorageService,
              private sessionStorage: SessionStorageService,
              private route: ActivatedRoute,
              private router: Router, private httpClient: HttpClient,  public toastr: ToastsManager, vcr: ViewContainerRef) {
    this.toastr.setRootViewContainerRef(vcr);
  }

  ngOnInit() {
    this.appService.hasAccessToken();
    this.route.params.subscribe((params: Params) => {
      this.studentId = params['studentId'];
      this.teacherId = params['teacherId'];
    });

    this.getSemesterList();

    // console.log(this.studentId);
    // console.log(this.teacherId);
  }

  getSemesterList() {
    const myParams = new HttpParams();
    this.httpClient.get(environment.apiUrl + 'headAccess/semesterList', {
      headers: this.appService.getHeadersWithAccessToken(),
      params: myParams
    })
      .subscribe(res => {
          // console.log(res);
          this.semesterList = res;
        },
        msg => {
          console.error('error');
        }
      );
  }


  getMeetingList() {
    const myParams = new HttpParams().append('studentId', this.studentId)
      .append('semesterId', this.selectedSemesterIdToSearchMeeting)
      .append('teacherId', this.teacherId);
    this.httpClient.get(environment.apiUrl + 'headAccess/teacherMeetingStudent/meetingList', {
      headers: this.appService.getHeadersWithAccessToken(),
      params: myParams
    })
      .subscribe(res => {
          // console.log(res);
          this.meetingList = res;
        },
        msg => {
          console.error('error');
        }
      );
  }
}
